/**
 * Initializes input element with value
 * @param {HTMLInputElement} input
 * @param {string} value
 * @returns {HTMLInputElement | void}
 */
export function updateCustomInput(input, value) {
  if (input && value) {
    const shadow = input.shadowRoot?.querySelector('input')
    if (shadow) shadow.value = value || ''
    input.value = value || ''
    return input
  }
}
